/** @jsx h */
import { h, Component } from 'preact'
import { initSingleLocationMap } from '../../../modules/mapbox'

export const mapBoxStyleLight = 'ciupgcpkh00le2hpbs35g71nq'

export const organizationInfo = collaborator => {
  if (!collaborator.avatarUrl) {
    return (
      <div>
        <p class='Text-bodySerif u-marginTop16'>Organisation</p>
        <p class='ClaimCard-name--collaboration'>{collaborator.name}</p>
      </div>
    )
  }
  return (
    <div class='ClaimCard-avatarSpacer ClaimCard-avatarSpacerBottom' />
  )
}

export const organizationAvatar = collaborator => {
  if (collaborator.avatarUrl) {
    return (
      <div>
        <div class='ClaimCard-avatarSpacer ClaimCard-avatarSpacerTop' />
        <img
          src={collaborator.avatarUrl}
          alt={collaborator.name}
          class='ClaimCard-avatar'
        />
      </div>
    )
  }
  return null
}

class CollaborationCard extends Component {
  componentDidMount () {
    initSingleLocationMap(
      $('.Mapbox-map--collaboratorCard'),
      $('.Mapbox-map--collaboratorCard').attr('id'),
      false
    )
  }

  render () {
    const { collaborator, action, footer, claim } = this.props

    const coordinates = claim.location
      ? `[${claim.location.longitude}, ${claim.location.latitude}]`
      : 'unknown'

    return (
      <div class='ClaimCard'>
        <div class='ClaimCard-header ClaimCard-header--collaboration'>
          <div class='Mapbox ClaimCard-map--collaboration'>
            <div
              class='Mapbox-map Mapbox-map--nonInteractive Mapbox-map--collaboratorCard'
              data-coordinates={coordinates}
              data-styleid={mapBoxStyleLight}
              id={`Mapbox-map--collaborator-${claim.id}`}
            />
            <div class='Mapbox-overlay' />
          </div>
          <div class='ClaimCard-title--collaboration'>Handshake</div>
          {organizationAvatar(collaborator)}
        </div>
        <div class='ClaimCard-section ClaimCard-section--collaboration'>
          {organizationInfo(collaborator)}
          {action}
        </div>
        <div class='ClaimCard-footer'>{footer}</div>
      </div>
    )
  }
}

CollaborationCard.defaultProps = {
  action: null,
  footer: null
}

export default CollaborationCard
